import { useEffect } from 'react';

import { useOneRosterAuth } from '@/hooks/useOneRosterAuth';
import { useDebugMode, useToggleDebugMode } from '@/lib/stores/debug-store';

const DEBUG_MODE_SHORTCUT = 'd';

export function DebugModeShortcut() {
  const { isAdmin, isSysAdmin, isLoading } = useOneRosterAuth();
  const toggleDebugMode = useToggleDebugMode();
  const isDebugMode = useDebugMode();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isAdmin && !isSysAdmin) return;
      // Toggle debug mode with Ctrl/Cmd + Shift + D
      if (
        event.key.toLowerCase() === DEBUG_MODE_SHORTCUT &&
        (event.metaKey || event.ctrlKey) &&
        event.shiftKey
      ) {
        event.preventDefault();
        toggleDebugMode();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggleDebugMode, isAdmin, isSysAdmin]);

  useEffect(() => {
    // Disables debug mode if user is not an admin
    if (!isLoading && !isAdmin && !isSysAdmin && isDebugMode) {
      toggleDebugMode();
    }
  }, [isAdmin, isSysAdmin, isDebugMode, toggleDebugMode, isLoading]);

  // Optionally show a small indicator when debug mode is enabled
  if (isDebugMode && (isAdmin || isSysAdmin)) {
    return (
      <div className="fixed bottom-1 right-1 bg-yellow-500 text-black px-2 py-1 rounded text-xs">
        Debug Mode
      </div>
    );
  }

  return null;
}
